// Facebook serves its OpenGraph tags HTML-escaped (`&#x1b0;` is `ư`) and gates share links behind a
// login wall, so a scraped preview comes back as a wall of entity codes instead of the post text.
// Telegram renders no preview at all for these links — match that and drop the card, leaving the
// plain link in the message.
const PREVIEW_BLOCKED_DOMAINS = ['facebook.com', 'fb.com', 'fb.watch', 'fb.me'];

export function shouldSkipWebPagePreview(url: string): boolean {
  const host = extractHost(url);

  return PREVIEW_BLOCKED_DOMAINS.some((domain) => host === domain || host.endsWith(`.${domain}`));
}

function extractHost(url: string): string {
  return url
    .replace(/^[a-z][a-z0-9+.-]*:\/\//i, '') // Protocol
    .replace(/^[^/?#]*@/, '') // Userinfo
    .split(/[/?#]/)[0]
    .split(':')[0] // Port
    .toLowerCase();
}
